var exports = {
  "DP": "x14bf3cd8--2a20fb--container-mobile",
};

module.exports = exports;
